import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';

const LabeledDropdown = props => {
  const { id: fieldId, labelError, labelText, children, inactive } = props;
  const {
    Block,
    Label,
    Input: { Select }
  } = UX2.Element;

  const styles = {
    display: 'block',
    marginBottom: 'xsmall'
  };

  return (
    <Block inactive style={{ paddingBottom: 'xsmall', pointerEvents: inactive ? 'none' : 'auto' }}>
      <Label alert={ labelError } htmlFor={ fieldId } children={ labelText } style={ styles } />
      <Select inactive tag='div' { ...props } children={ children } />
    </Block>
  );
};

LabeledDropdown.propTypes = {
  labelText: PropTypes.string.isRequired,
  labelError: PropTypes.bool,
  id: PropTypes.any,
  children: PropTypes.any,
  inactive: PropTypes.bool
};

LabeledDropdown.defaultProps = {
  labelText: '',
  labelError: false,
  inactive: false
};

export default LabeledDropdown;
